/**
 * @generated SignedSource<<4d9a33f89dde0aa48ffad97b2618a1d3>>
 * @relayHash eaf3e67aa2140a51195ea6cf91847cf3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 204ec2666e902a1e7ef54a9a28e4780ad4d9522adaae83d6aa5ce21deffe94a2

import type { ConcreteRequest, Query } from 'relay-runtime';
export type userPermContextProviderQuery$variables = {
  atlassianAccountId: string;
  cloudID: string;
};
export type userPermContextProviderQuery$data = {
  readonly devai_rovoDevAgentsUser: {
    readonly hasProductAccess: boolean | null | undefined;
    readonly isAdmin: boolean | null | undefined;
  } | null | undefined;
  readonly devai_rovoDevAgentsWorkspace: {
    readonly status: string | null | undefined;
  } | null | undefined;
};
export type userPermContextProviderQuery = {
  response: userPermContextProviderQuery$data;
  variables: userPermContextProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atlassianAccountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudID"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudID"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "atlassianAccountId",
        "variableName": "atlassianAccountId"
      },
      (v2/*: any*/)
    ],
    "concreteType": "DevAiUser",
    "kind": "LinkedField",
    "name": "devai_rovoDevAgentsUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "hasProductAccess"
      },
      {
        "kind": "ScalarField",
        "name": "isAdmin"
      }
    ]
  },
  {
    "args": [
      (v2/*: any*/)
    ],
    "concreteType": "DevAiWorkspace",
    "kind": "LinkedField",
    "name": "devai_rovoDevAgentsWorkspace",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "status"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "userPermContextProviderQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "userPermContextProviderQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "204ec2666e902a1e7ef54a9a28e4780ad4d9522adaae83d6aa5ce21deffe94a2",
    "metadata": {},
    "name": "userPermContextProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a9496215ed8080b04d355806fd2bc7a1";

export default node;
